// Returns true when the provided value's length is within the maxLength bound.
// Converts non-string inputs to strings, with an option to trim whitespace.
export const characterLengthCheck = (value = "", maxLength = 0, { trim = false } = {}) => {
  if (!Number.isInteger(maxLength) || maxLength < 0) {
    throw new TypeError("maxLength must be a non-negative integer");
  }

  if (value === null || value === undefined) {
    return false;
  }

  const normalized = trim ? String(value).trim() : String(value);
  return normalized.length <= maxLength;
};